import api from "./api";

export interface AuthModeResponse {
  authMode: "local" | "azure_ad" | "ad_ldap";
  isExternalProvider: boolean;
  protocol: string;
  responseType: string;
  grantType: string;
  usePkce: boolean;
  authorityUrl: string | null;
  clientId: string | null;
  redirectUri: string | null;
  scopes: string[];
}

export const authenticationModeService = {
  getAuthenticationMode: async (): Promise<AuthModeResponse> => {
    const { data } = await api.get(
      "/v2/UserCustomerAuthentication/GetAuthenticationMode",
    );
    return data;
  },
};
